import React from 'react';
import ErrorCard from '../ErrorCard/ErrorCard';
import './ErrorPopup.scss';

const ErrorPopup = ({ errorMessage, dismissError }) => (
  <div className={`error-popup ${errorMessage ? 'active' : null}`}>
    <div
      className="overlay"
      role="button"
      tabIndex={0}
      onClick={dismissError}
      aria-label="Dismiss error"
    />
    <ErrorCard errorMessage={errorMessage} dismissError={dismissError} />
  </div>
);

export default ErrorPopup;
